import { Box } from '@gemini/core';
import { InfoState } from '@gemini/ui';
import { useTranslation } from '@aviv-unified-frontend/runtime/i18n';
import { NAME_SPACE } from '@mfe-presentation/hooks/useLoadTranslations';

const ErrorFallback = ({ mode = 'fullscreen' }: { mode?: 'fullscreen' | 'partial' }) => {
    const { t } = useTranslation(NAME_SPACE);

    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            height={mode === 'fullscreen' ? '100vh' : 'auto'}
            whiteSpace="pre-wrap"
            paddingVertical="spacing.16"
            paddingHorizontal="spacing.16"
            textAlign="center"
        >
            <InfoState
                title={t('common.popover.error.wlef.serverError.title')}
                description={
                    mode === 'fullscreen'
                        ? t('common.popover.error.wlef.serverError.message')
                        : t('common.popover.error.wlef.serverError.shortMessage')
                }
                {...(mode === 'fullscreen'
                    ? {
                          startButtonProps: {
                              children: t('common.popover.cta.refresh') as 'string',
                              onPress: () => {
                                  // reset the entire application from a clean state
                                  // it will ensures that there are no duplicate script or resource loads, but will lead to data loss
                                  window.location.reload();
                              },
                          },
                      }
                    : {})}
            />
        </Box>
    );
};

export default ErrorFallback;
